import { render, staticRenderFns } from "./RecoveryPasswordPage.vue?vue&type=template&id=7839124c&scoped=true&"
import script from "./RecoveryPasswordPage.vue?vue&type=script&lang=js&"
export * from "./RecoveryPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryPasswordPage.vue?vue&type=style&index=0&id=7839124c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839124c",
  null
  
)

export default component.exports